'use client'

import createStoreProvider from '@/components/context-factories/create-store-provider'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface AuthDialogStore {
  showDialog: boolean
  showLogin: boolean
  showResetPassword: boolean
  toggleShowDialog: () => void
  setShowPasswordReset: (show: boolean) => void
  toggleShowLogin: () => void
}

const init = (initialState?: Partial<AuthDialogStore>) => {
  const store = create<AuthDialogStore>()(
    devtools(
      (set) => ({
        showDialog: false,
        showLogin: true,
        showResetPassword: false,
        ...initialState,
        toggleShowDialog: () =>
          set((state) => {
            const showDialog = !state.showDialog
            return {
              showDialog,
              showLogin: showDialog || state.showLogin,
            }
          }),
        toggleShowLogin: () =>
          set((state) => ({
            showLogin: !state.showLogin,
          })),
        setShowPasswordReset: (show) =>
          set({
            showResetPassword: show,
          }),
      }),
      {
        name: 'auth-dialog-store',
      },
    ),
  )

  return store
}

export const [AuthDialogStoreProvider, useAuthDialogStore] =
  createStoreProvider(init)
